// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__8SF3T","row":"ProcedureTreatmentSummary_row__1OtR4"};